import React from 'react'
import PropTypes from 'prop-types'

const MostrarHTML = (props) => {
  const { msjHTML } = props

  const strToHTML = (str) => {
    var dom = document.createElement('div')
    dom.innerHTML = str
    return dom
  }

  // const htmlDecode = (input) => {
  //   var e = document.createElement('div')
  //   e.innerHTML = input
  //   return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
  // }

  return (
    // <div dangerouslySetInnerHTML={{ __html: htmlDecode(msjHTML) }} />
    <div dangerouslySetInnerHTML={{ __html: strToHTML(msjHTML) }} />
  )
}

MostrarHTML.propTypes = {
  msjHTML: PropTypes.string,
}

export default MostrarHTML
